import React, { useEffect, useState, useRef } from 'react';
import P from 'prop-types';
// import { QRCode } from 'react-qrcode-logo';
// import { QRCodeSVG } from 'qrcode.react';
import QRCodeStyling from 'qr-code-styling';
import { ModalQrCodeContext } from './context';
import environment from '../../config/environment';

import IconClose from '../../assets/images/icon-close-qr-code-modal.svg';
import LogoY from '../../assets/images/logo-y-fundo-branco.svg';

const qrCodeCreate = new QRCodeStyling({
  width: 300,
  height: 300,
  data: 'asssss',
  margin: 0,
  qrOptions: {
    typeNumber: '3',
    mode: 'Byte',
    errorCorrectionLevel: 'M',
  },
  imageOptions: {
    hideBackgroundDots: true,
    imageSize: 0.4,
    margin: 0,
  },
  dotsOptions: {
    type: 'rounded',
    color: '#000000',
  },
  backgroundOptions: {
    color: '#ffffff',
  },
  image: LogoY,
  dotsOptionsHelper: {
    colorType: {
      single: true,
      gradient: false,
    },
    gradient: {
      linear: true,
      radial: false,
      color1: '#6a1a4c',
      color2: '#6a1a4c',
      rotation: '0',
    },
  },
  cornersSquareOptions: {
    type: 'extra-rounded',
    color: '#000000',
  },
  cornersSquareOptionsHelper: {
    colorType: {
      single: true,
      gradient: false,
    },
    gradient: {
      linear: true,
      radial: false,
      color1: '#000000',
      color2: '#000000',
      rotation: '0',
    },
  },
  cornersDotOptions: {
    type: 'dot',
    color: '#000000',
  },
  cornersDotOptionsHelper: {
    colorType: {
      single: true,
      gradient: false,
    },
    gradient: {
      linear: true,
      radial: false,
      color1: '#000000',
      color2: '#000000',
      rotation: '0',
    },
  },
  backgroundOptionsHelper: {
    colorType: {
      single: true,
      gradient: false,
    },
    gradient: {
      linear: true,
      radial: false,
      color1: '#ffffff',
      color2: '#ffffff',
      rotation: '0',
    },
  },
});

export const ModalQrCodeProvider = ({ children }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [qrCode, setQrCode] = useState('ssddass');
  const ref = useRef(null);

  // useEffect(() => {
  // 	console.log('chamei');
  // 	qrCodeCreate.append(ref.current);
  // 	qrCodeCreate.update({
  // 		data: qrCode,
  // 	});
  // }, []);

  useEffect(() => {
    qrCodeCreate.update({
      data: `${environment.yapps.qrCodeBaseUrl}/${qrCode}/`,
    });
  }, [qrCode]);

  function viewQrCode(qrCode) {
    window.scrollTo(0, 0);
    document.body.classList.add('popup-open');
    setTimeout(() => {
      qrCodeCreate.append(ref.current);
    }, 10);
    setQrCode(qrCode);
    setModalVisible(true);
  }

  return (
    <>
      <ModalQrCodeContext.Provider value={{ viewQrCode }}>
        {children}
      </ModalQrCodeContext.Provider>
      {modalVisible && (
        <>
          <section className="popup">
            <div className="content-popup">
              <div className="close-popup">
                <a
                  href="#"
                  title="Fechar"
                  onClick={(e) => {
                    e.preventDefault();
                    document.body.classList.remove('popup-open');
                    setQrCode('');
                    setModalVisible(false);
                  }}
                >
                  <img src={IconClose} alt="Fechar" />
                </a>
              </div>
              {/* <div className="center">
								<QRCode
									value={`${environment.yapps.qrCodeBaseUrl}/${qrCode}/`}
									id="qrCodeId"
									logoImage={LogoY}
									logoWidth={80}
									eyeRadius={50}
									size={300}
								/>
							</div>
							<div className="center">
								<QRCodeSVG
									value={`${environment.yapps.qrCodeBaseUrl}/${qrCode}/`}
									size={300}
									eyeRadius={50}
								/>
							</div> */}
              <div className="center" ref={ref}></div>
            </div>
          </section>
          <div className="overlay"></div>
        </>
      )}
    </>
  );
};

ModalQrCodeProvider.propTypes = {
  children: P.node.isRequired,
};
